var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"text-center bold mt-3"},[_vm._v(_vm._s(_vm._f("calendar")(_vm.date)))]),_vm._l((_vm.messageStreaks),function(ms,index){return _c('message-streak',{key:index,attrs:{"messages":ms}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }